var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"table-box"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"table-item"},[_vm._t("default",null,{"row":item,"index":index})],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }